export const CAMPAIGN_NAME_OPTION = 'campaignNameOption'
export const CAMPAIGN_NAME_CONVENTION_OPTION = 'campaignNameConventionOption'
export const CUSTOM_CAMPAIGN_NAME_OPTION = 'customCampaignNameOption'
export const CUSTOM_CAMPAIGN_NAME = 'customCampaignName'

export const SHORT_CAMPAIGN_DESCRIPTION = 'shortCampaignDescription'
export const EXPECTED_START_DATE = 'expectedStartDate'
export const OPTIONAL_TAG = 'optionalTag'

export const CONVENTION_NAME_DATE_FORMAT = 'yyyyMMdd'

export const campaignNameOptions = [
  { value: CAMPAIGN_NAME_CONVENTION_OPTION, label: 'Naming Convention' },
  { value: CUSTOM_CAMPAIGN_NAME_OPTION, label: 'Custom' }
]
